import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      {
        field: 'created_at',
        title: i18n.t('scope.text_657'),
        width: 200,
        sortable: true,
        formatter: ({ cellValue }) => {
          return cellValue ? this.$moment(cellValue).format('YYYY-MM-DD') : '-'
        },
      },
      {
        field: 'ip',
        title: i18n.t('scope.text_658'),
      },
      {
        field: 'version',
        title: i18n.t('scope.text_659'),
      },
      {
        field: 'iso_name',
        title: i18n.t('scope.text_660'),
      },
    ]
  },
}
